var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWebhooks = function SvgWebhooks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.416 18.077h-5.723L48.73 27.04v5.723l8.964 8.964h5.723l8.964-8.964V27.04l-8.964-8.963ZM58.67 62.681l-2.172-2.17H44.726l-2.171 2.17v11.773l2.171 2.17h11.772l2.171-2.17V62.682ZM23.504 38.335v-7.04l2.174-2.072h15.108",
    stroke: "currentColor",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.504,
    cy: 46.618,
    r: 8.283,
    stroke: "currentColor",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.424 60.432V49.517l-2.175-2.07H32.615M36.647 35.902l5.063-5.063v-3.231l-5.063-5.063",
    stroke: "currentColor",
    strokeWidth: 3
  })));
};
export default SvgWebhooks;